// components/ui/LanguageSelect.tsx
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { t } from "i18next";
import { interfaceLanguageOptions } from "@/common/constants";

interface Props {
  value: string;
  onChange: (language: string) => void;
}

export const DisplayLanguageSelect = ({
  value,
  onChange,
}: Props): JSX.Element => {
  return (
    <div className="space-y-2">
      <Label>
        {t("settings.account.interfacePreferences.interfaceLanguageLabel")}
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue
            placeholder={t(
              "settings.account.interfacePreferences.interfaceLanguagePlaceholder"
            )}
          />
        </SelectTrigger>
        <SelectContent>
          {interfaceLanguageOptions.map((lang) => (
            <SelectItem key={lang.value} value={lang.value}>
              {lang.flag} {lang.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
